/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M16 19.5052V14.4948C16 14.0092 16 13.7664 16.1012 13.6326C16.1894 13.516 16.3243 13.4439 16.4702 13.4351C16.6377 13.4251 16.8397 13.5598 17.2438 13.8292L21.0015 16.3344C21.3354 16.5569 21.5023 16.6682 21.5605 16.8085C21.6113 16.9311 21.6113 17.0689 21.5605 17.1915C21.5023 17.3318 21.3354 17.4431 21.0015 17.6656L17.2438 20.1708C16.8397 20.4402 16.6377 20.5749 16.4702 20.5649C16.3243 20.5561 16.1894 20.484 16.1012 20.3674C16 20.2336 16 19.9908 16 19.5052Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 4H20M2 9H16M2 14H11M2 19H9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M16 19.5052V14.4948C16 14.0092 16 13.7664 16.1012 13.6326C16.1894 13.516 16.3243 13.4439 16.4702 13.4351C16.6377 13.4251 16.8397 13.5598 17.2438 13.8292L21.0015 16.3344C21.3354 16.5569 21.5023 16.6682 21.5605 16.8085C21.6113 16.9311 21.6113 17.0689 21.5605 17.1915C21.5023 17.3318 21.3354 17.4431 21.0015 17.6656L17.2438 20.1708C16.8397 20.4402 16.6377 20.5749 16.4702 20.5649C16.3243 20.5561 16.1894 20.484 16.1012 20.3674C16 20.2336 16 19.9908 16 19.5052Z"
				fill="currentColor"
			/>
			<path
				d="M2 4H20M2 9H16M2 14H11M2 19H9M21.0015 17.6656L17.2438 20.1708C16.8397 20.4402 16.6377 20.5749 16.4702 20.5649C16.3243 20.5561 16.1894 20.484 16.1012 20.3674C16 20.2336 16 19.9908 16 19.5052V14.4948C16 14.0092 16 13.7664 16.1012 13.6326C16.1894 13.516 16.3243 13.4439 16.4702 13.4351C16.6377 13.4251 16.8397 13.5598 17.2438 13.8292L21.0015 16.3344C21.3354 16.5569 21.5023 16.6682 21.5605 16.8085C21.6113 16.9311 21.6113 17.0689 21.5605 17.1915C21.5023 17.3318 21.3354 17.4431 21.0015 17.6656Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2 3.25C1.58579 3.25 1.25 3.58579 1.25 4C1.25 4.41421 1.58579 4.75 2 4.75H20C20.4142 4.75 20.75 4.41421 20.75 4C20.75 3.58579 20.4142 3.25 20 3.25H2ZM2 8.25C1.58579 8.25 1.25 8.58579 1.25 9C1.25 9.41421 1.58579 9.75 2 9.75H16C16.4142 9.75 16.75 9.41421 16.75 9C16.75 8.58579 16.4142 8.25 16 8.25H2ZM2 13.25C1.58579 13.25 1.25 13.5858 1.25 14C1.25 14.4142 1.58579 14.75 2 14.75H11C11.4142 14.75 11.75 14.4142 11.75 14C11.75 13.5858 11.4142 13.25 11 13.25H2ZM2 18.25C1.58579 18.25 1.25 18.5858 1.25 19C1.25 19.4142 1.58579 19.75 2 19.75H9C9.41421 19.75 9.75 19.4142 9.75 19C9.75 18.5858 9.41421 18.25 9 18.25H2ZM18.235 13.5886L18.235 13.5886L20.9558 15.4025C21.757 15.9366 22.1576 16.2037 22.2972 16.5403C22.4193 16.8346 22.4193 17.1654 22.2972 17.4597C22.1576 17.7963 21.757 18.0634 20.9558 18.5975L18.235 20.4114C17.2654 21.0578 16.7805 21.381 16.3785 21.357C16.0282 21.3361 15.7047 21.163 15.493 20.8831C15.25 20.5619 15.25 19.9792 15.25 18.8138V15.1862C15.25 14.0208 15.25 13.4381 15.493 13.1169C15.7047 12.837 16.0282 12.6639 16.3785 12.643C16.7805 12.619 17.2653 12.9422 18.235 13.5886Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 9H16M2 4H13M16 4H20M7 14H12M2 14H4M2 19H9M21.0015 17.6656L17.2438 20.1708C16.8397 20.4402 16.6377 20.5749 16.4702 20.5649C16.3243 20.5561 16.1894 20.484 16.1012 20.3674C16 20.2336 16 19.9908 16 19.5052V14.4948C16 14.0092 16 13.7664 16.1012 13.6326C16.1894 13.516 16.3243 13.4439 16.4702 13.4351C16.6377 13.4251 16.8397 13.5598 17.2438 13.8292L21.0015 16.3344C21.3354 16.5569 21.5023 16.6682 21.5605 16.8085C21.6113 16.9311 21.6113 17.0689 21.5605 17.1915C21.5023 17.3318 21.3354 17.4431 21.0015 17.6656Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 4H20M2 9H16M2 14H11M2 19H9M21.0015 17.6656L17.2438 20.1708C16.8397 20.4402 16.6377 20.5749 16.4702 20.5649C16.3243 20.5561 16.1894 20.484 16.1012 20.3674C16 20.2336 16 19.9908 16 19.5052V14.4948C16 14.0092 16 13.7664 16.1012 13.6326C16.1894 13.516 16.3243 13.4439 16.4702 13.4351C16.6377 13.4251 16.8397 13.5598 17.2438 13.8292L21.0015 16.3344C21.3354 16.5569 21.5023 16.6682 21.5605 16.8085C21.6113 16.9311 21.6113 17.0689 21.5605 17.1915C21.5023 17.3318 21.3354 17.4431 21.0015 17.6656Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 4C1.25 3.58579 1.58579 3.25 2 3.25H20C20.4142 3.25 20.75 3.58579 20.75 4C20.75 4.41421 20.4142 4.75 20 4.75H2C1.58579 4.75 1.25 4.41421 1.25 4ZM1.25 9C1.25 8.58579 1.58579 8.25 2 8.25H16C16.4142 8.25 16.75 8.58579 16.75 9C16.75 9.41421 16.4142 9.75 16 9.75H2C1.58579 9.75 1.25 9.41421 1.25 9ZM1.25 14C1.25 13.5858 1.58579 13.25 2 13.25H11C11.4142 13.25 11.75 13.5858 11.75 14C11.75 14.4142 11.4142 14.75 11 14.75H2C1.58579 14.75 1.25 14.4142 1.25 14ZM1.25 19C1.25 18.5858 1.58579 18.25 2 18.25H9C9.41421 18.25 9.75 18.5858 9.75 19C9.75 19.4142 9.41421 19.75 9 19.75H2C1.58579 19.75 1.25 19.4142 1.25 19Z"
				fill="currentColor"
			/>
			<path
				d="M18.235 13.5886C17.2654 12.9422 16.7805 12.619 16.3785 12.643C16.0282 12.6639 15.7047 12.8371 15.493 13.1169C15.25 13.4381 15.25 14.0208 15.25 15.1862V18.8139C15.25 19.9793 15.25 20.5619 15.493 20.8832C15.7047 21.163 16.0282 21.3361 16.3785 21.3571C16.7805 21.3811 17.2654 21.0578 18.235 20.4114L20.9558 18.5976C21.757 18.0634 22.1576 17.7963 22.2972 17.4597C22.4193 17.1654 22.4193 16.8346 22.2972 16.5403C22.1576 16.2037 21.757 15.9366 20.9558 15.4025L18.235 13.5886Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
